import aos from 'aos';
import Player from '@vimeo/player/src/player';
import 'core-js';
import "regenerator-runtime/runtime";

import jQuery from "jquery";
window.$ = window.jQuery = jQuery;


// import './../sass/style.scss';

aos.init();

aos.init({
  duration: 600,
  delay: 100
});

$(document).ready(function () {
      var iframe = document.querySelector('.movie-content .movie-embed iframe');

      if(iframe){
          var player = new Player(iframe);
          let seconds = $('#credits').text();
          var showQuiz = true;
          let countOnQuiz = 1;
          var rightAnswersCount = 0;

          player.on('timeupdate', function(data) {

              if(data.seconds > parseInt(seconds) && showQuiz) {
                $('.main .movie-single .movie-content .movie-embed #quiz').css('display','block');
              }
          });

          var allanswersright = true;

          $('.questions .answer-button').on('click', function() {
              let yourAnswer = $(this).data('answer');
              let currentQuestion = $(this).data('question');
              let rightAnswer = $('#right_answer-' + currentQuestion).data('right').toString();
              let total = $('#total-questions').data('value');

              rightAnswer = rightAnswer.split(',');

              if(rightAnswer.indexOf(yourAnswer.toString()) === -1) {
                  allanswersright = false;
              } else {
                  rightAnswersCount++;
              }

              $('.questions .answer-button').each(function() {
                  if(rightAnswer.indexOf($(this).data('answer').toString()) !== -1  ) {
                      $(this).addClass('right-answer');
                  } else {
                      $(this).addClass('wrong-answer');
                  }
              });

              setTimeout(function(){

                  $('.question-to-answer-' + countOnQuiz).css('display','none');

                  if(countOnQuiz < total) {

                      countOnQuiz++
                      $('.questions .answer-button').removeClass('wrong-answer');
                      $('.questions .answer-button').removeClass('right-answer');
                      $('.question-to-answer-' + countOnQuiz).css('display','block');

                  } else {

                      $('#all-right-answers').toggle();
                      $('#your-score').prepend('Točno ste odgovorili na ' + rightAnswersCount + ' od ' + total + ' pitanja');

                      if(allanswersright) {
                          allanswersright = 'madeit';
                      }

                      if(allanswersright === 'madeit'){
                          $('#try-again').css('display','none');
                      } else {
                          $('#try-again').css('display','block');
                      }

                      $.ajax({
                          url: ajaxurl,
                          type: 'post',
                          data: {
                              action: 'quiz_question',
                              movie_id: $('#movie_id').data('movie'),
                              madeit : allanswersright
                          },
                          error: function(response) {
                              console.log(response)
                          },
                          success: function(response) {


                          }
                      });

                  }

              }, 1000);

          });

          $('#close-quiz').on('click', function(e) {
                e.preventDefault();
                $('#quiz').css('display','none');
                showQuiz = false;
            });

          $('#try-again').on('click', function(e) {
              showQuiz = true;
              countOnQuiz = 1;
              rightAnswersCount = 0;
              allanswersright = true;
              $('#all-right-answers').css('display','none');
              $('.questions .answer-button').removeClass('wrong-answer');
              $('.questions .answer-button').removeClass('right-answer');
              $('#your-score').empty();
              $('.question-to-answer').css('display','none');
              $('.question-to-answer-' + countOnQuiz).css('display','block');
          });

      }
});